module.exports = __webpack_public_path__ + "static/media/16UNODC35.a9055a9f.jpg";